import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M9.49 13.846a.643.643 0 0 1-.906-.07l-2.572-3a.643.643 0 0 1 0-.838l2.572-3a.643.643 0 0 1 .975.837L7.898 9.714h2.245a2.357 2.357 0 1 0 0-4.714H3.5v7.929a.642.642 0 1 1-1.286 0V2.643a.644.644 0 0 1 1.098-.455c.12.12.188.284.188.455v1.07h6.643a3.643 3.643 0 0 1 0 7.287H7.897l1.662 1.938c.231.27.2.677-.07.908Z';
const draw24px =
  'M3.429 22a.857.857 0 0 1-.857-.857V2.857a.857.857 0 0 1 1.714 0V5.43h11.143a6 6 0 1 1 0 12H11.03l2.757 3.15a.858.858 0 0 1-1.29 1.128l-4-4.57a.858.858 0 0 1 0-1.13l4-4.572a.858.858 0 0 1 1.29 1.13l-2.757 3.15h4.398a4.286 4.286 0 1 0 0-8.572H4.286v14a.857.857 0 0 1-.857.857Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const ArrowWrapIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'arrowWrap'),
) as IconWithRender;

ArrowWrapIcon.displayName = 'ArrowWrapIcon';
ArrowWrapIcon.propTypes = Icon.propTypes;
ArrowWrapIcon.renderIcon = (props) => <ArrowWrapIcon {...props} />;
export default ArrowWrapIcon;
